(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('TradePolicyRule', TradePolicyRule);

    TradePolicyRule.$inject = ['$resource'];

    function TradePolicyRule ($resource) {
        var resourceUrl =  'api/trade-policy-rules/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
